import { decodeAuthToken } from 'utils/authenticationUtils';
import useAuthToken from '../useAuthToken/useAuthToken';

export default function useKeyAuthorization() {
  const token = useAuthToken();
  return decodeAuthToken(token || '').keyAuthorization;
}
